export default __webpack_public_path__ + "static/banner-financing-your-home-improvements-ad464e54fe3812f9eeec74980b32a0f4.jpg";